<template>
  <div class="d-none d-lg-inline sidebar" :class="[isOpen && 'sidebar-open']">
    <b-nav vertical>
      <b-nav-item
        v-if="permissions.isAdminAndAbove && permissions.isUsePurchase"
        class="sidebar-icon-order"
        :href="$appConfig.ScreenUrl.purchaseOrderList"
        @click="onClickNavItem($appConfig.serviceID.purchase)"
        v-b-tooltip="{
          disabled: isOpen,
          delay: { show: 100 },
          boundary: 'viewport',
          placement: 'left',
          noninteractive: true,
          customClass: 'sidebar-tooltip',
          title: $t('受発注管理'),
        }"
      >
        {{ $t('受発注管理') }}
      </b-nav-item>
      <b-nav-item
        v-if="permissions.isUseInventory"
        class="sidebar-icon-stock"
        :href="$appConfig.ScreenUrl.ship"
        @click="onClickNavItem($appConfig.serviceID.inventory)"
        v-b-tooltip="{
          disabled: isOpen,
          delay: { show: 100 },
          boundary: 'viewport',
          placement: 'left',
          noninteractive: true,
          customClass: 'sidebar-tooltip',
          title: $t('在庫管理'),
        }"
      >
        {{ $t('在庫管理') }}
      </b-nav-item>
      <b-nav-item
        v-if="permissions.isUseSmallLot"
        class="sidebar-icon-progress"
        :href="$appConfig.ScreenUrl.scheduleOrder"
        @click="onClickNavItem($appConfig.serviceID.smallLot)"
        v-b-tooltip="{
          disabled: isOpen,
          delay: { show: 100 },
          boundary: 'viewport',
          placement: 'left',
          noninteractive: true,
          customClass: 'sidebar-tooltip',
          title: $t('工程管理'),
        }"
      >
        {{ $t('工程管理') }}
      </b-nav-item>
      <b-nav-item
        v-if="permissions.isMasterAdminAndAbove"
        class="sidebar-icon-settings"
        :href="$appConfig.ScreenUrl.settingMenu"
        @click="onClickNavItem($appConfig.serviceID.base)"
        v-b-tooltip="{
          disabled: isOpen,
          delay: { show: 100 },
          boundary: 'viewport',
          placement: 'left',
          noninteractive: true,
          customClass: 'sidebar-tooltip',
          title: $t('各種設定'),
        }"
      >
        {{ $t('各種設定') }}
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
export default {
  props: {
    /** サイドバーが展開されているか */
    isOpen: Boolean,
    /** サービスの使用権限を取得する関数群 */
    permissions: {},
  },
  methods: {
    /** ナビゲーションアイテムをクリック時の処理 */
    onClickNavItem(serviceID) {
      this.$emit('saveServiceID', serviceID)
    },
  },
}
</script>

<style lang="scss" scoped>
.sidebar {
  // スクロールバーをカスタマイズする。（横幅が太いと見栄えが悪いため）
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background-color: lightgray;
  }
  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  }

  // サイドバー単体でスクロールさせる。
  overflow-x: hidden;
  overflow-y: auto;

  // メインコンテンツとの境界線を引く。
  border-right: 1px solid #ebebeb;

  // 縮小時のサイズ。
  width: 60px;
  min-width: 60px;
  &-open {
    // 展開時のサイズ。
    width: 200px;
    min-width: 200px;
  }

  .nav {
    > .nav-item {
      background-color: transparent;
      transition: background-color 0.1s;
      &:hover {
        background-color: #f0ffe4;
      }

      > .nav-link {
        padding: 1rem;
        color: #252525;
        font-size: 1.4rem;
        font-weight: bold;
        letter-spacing: 0.2rem;
        line-height: 4rem;
        text-indent: 5rem;
        white-space: nowrap;
      }
    }
  }

  &-icon {
    // 受発注管理
    &-order {
      background-image: url('../../assets/images/icon-multiple-stop.svg');
      background-repeat: no-repeat;
      background-position: 1.8rem 1.8rem;
    }
    // 在庫管理
    &-stock {
      background-image: url('../../assets/images/icon-inventory.svg');
      background-repeat: no-repeat;
      background-position: 1.8rem 1.8rem;
    }
    // 工程管理
    &-progress {
      background-image: url('../../assets/images/icon-event-note.svg');
      background-repeat: no-repeat;
      background-position: 1.8rem 1.8rem;
    }
    // 各種設定
    &-settings {
      background-image: url('../../assets/images/icon-settings.svg');
      background-repeat: no-repeat;
      background-position: 1.8rem 1.8rem;
    }
  }

  &-tooltip {
    font-size: 1.2rem;
    left: -9rem !important;
  }
}
</style>
